var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.legacySubscriptions && _vm.apparatusDetails
    ? _c(
        "div",
        [
          _c(
            "b-row",
            {
              staticClass: "mb-0 pb-0 current-plan",
              attrs: { "align-h": "center", "no-gutters": "" }
            },
            [
              _c("b-col", { staticClass: "text-center" }, [
                _c(
                  "div",
                  {
                    staticClass: "row mb-3 ml-3 mr-3",
                    attrs: { "align-h": "around" }
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-center plan-details-header-notice mx-auto"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("xUpgradeToNewSubscriptionTitle")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "text-center plan-details-header",
                        attrs: {
                          "data-test-hook": "new-plan-with-upgrade-text"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("xUpgradeToNewSubscriptionText", {
                                0: _vm.getCurrencyString(
                                  _vm.selectedProduct.cost
                                ),
                                1: _vm.closestNextBillingDate
                              })
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              ])
            ],
            1
          ),
          _c("SubscriptionCard", {
            attrs: {
              "subscription-product": _vm.selectedProduct,
              "existing-apparatuses": [],
              "apparatuses-to-add": _vm.apparatusesOnNewPlan,
              "is-new-plan": true,
              "monthly-paid-product": _vm.monthlyPaidProduct,
              "annual-paid-product": _vm.annualPaidProduct,
              "hide-badge": true,
              "is-highlighted": true
            },
            on: { setSelectedProduct: _vm.setSelectedProduct }
          }),
          _c(
            "b-row",
            { staticClass: "mt-3", attrs: { "no-gutters": "" } },
            [
              _c(
                "b-col",
                { staticClass: "float-left", attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: {
                        variant: "warning",
                        disabled:
                          _vm.isCreatingPurchaseIntent ||
                          _vm.isCancellingLegacyPlans,
                        "data-test-hook":
                          "subscription-new-tank-with-basic-confirm-plan-button"
                      },
                      on: {
                        click: _vm.immediateCancelLegacyAndProceedToPayment
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.$t("xUpgradeNow")) + " "),
                      _vm.isCreatingPurchaseIntent ||
                      _vm.isCancellingLegacyPlans
                        ? _c("b-spinner", { staticClass: "ml-2" })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }